import React from 'react'
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography
} from '@mui/material'
import { rxOpenConfirm } from '../lib/rx_subject'

const Confirm = () => {
  const [open, setOpen] = React.useState(false)
  const [confirm, setConfirm] = React.useState({})

  React.useEffect(() => {
    const subscription = rxOpenConfirm.subscribe(confirm => {
      setConfirm(confirm)
      setOpen(true)
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  const ok = evt => {
    evt.preventDefault()
    setOpen(false)
    if (confirm.close) {
      confirm.close(true)
    }
  }

  const cancel = () => {
    setOpen(false)
    if (confirm.close) {
      confirm.close(false)
    }
  }

  return (
    <Dialog className="confirm-dialog" open={open}
            aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">{confirm.title}</DialogTitle>
      <DialogContent>
        <form id="confirm-form" onSubmit={ok}>
          <Typography className="message">
            {confirm.message}
          </Typography>
        </form>
      </DialogContent>
      <DialogActions>
        <Button type="submit" form="confirm-form"
                className="ok" color="primary" onClick={ok}>
          OK
        </Button>
        <Button className="cancel" color="secondary" onClick={cancel}>
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Confirm
